import { useContext, useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import ImageLoad from '../ImageLoad';
import { MyContext } from '../../Context/MyProvider';
import secureLocalStorage from 'react-secure-storage';
import Btn_loader from '../Btn_loader';
import { socket } from '../../socket';
import BookApoint from './BookApoint';
import PageLoading from '../PageLoading';
import { useTranslation } from 'react-i18next';

const Chat = () => {

    const { t } = useTranslation();
    const { BaseUrl, HandleCallApi, setIsToast, setToastMsg, setIsRating, setRatingData, formatPrice } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [isOnline, setIsOnline] = useState(false);
    const [isTyping, setIsTyping] = useState(false);
    const isMyTypingRef = useRef(false);
    const typingTimeoutRef = useRef(null);
    const [inputmsg, setInputMsg] = useState("");
    const [userdata, setUserData] = useState("");
    const [chattime, setChatTime] = useState("00:00");
    const [running, setRunning] = useState(true);
    const [allchat, setAllChat] = useState([]);
    const [isend, setIsEnd] = useState(false);
    const [apiloading, setApiLoading] = useState("");
    const [status, setStatus] = useState("");
    const [kundlilist, setKundliList] = useState([]);
    const [ischatpaymodel, setIsChatPayModel] = useState(false);
    const [freeMinit, setFreeMinit] = useState("00:00");
    const [page, setPage] = useState(1);
    const [lastScrollTop, setLastScrollTop] = useState("");
    const [hasMore, setHasMore] = useState(true);

    const Location = useLocation();
    const navigate = useNavigate();
    const BookData = Location.state;
    const chatBoxBodyRef = useRef(null);
    const UserRef = useRef(false);
    const NoMoreDataRef = useRef(true);

    const Userid = secureLocalStorage.getItem("Userid");
    const Currency = secureLocalStorage.getItem("currency");


    useEffect(() => {
        if (!Userid || !BookData?.appoint_id) return;

        const handleEndChat = (data) => {
            setIsToast(true);
            setToastMsg(data.message);
            setIsRating(true);
            navigate("/");
        }

        const handleWebNewChatReaload = (data) => {
            if (!data) return;
            setAllChat((prev) => {
                const CopyData = [...prev];
                const Chat = {
                    date: data.date,
                    id: "",
                    images: data.images,
                    message: data.messages,
                    status: "2"
                }
                if (CopyData.length > 0) {
                    const LastIndex = CopyData.length - 1;
                    const UpdateChat = {
                        ...CopyData[LastIndex],
                        chat: [Chat, ...CopyData[LastIndex].chat]
                    }
                    CopyData[LastIndex] = UpdateChat;
                    return CopyData;
                }
            });
        }

        const handleNewChat = (data) => {
            setAllChat((prev) => {
                const CopyData = [...prev];
                const Chat = {
                    date: data.date,
                    id: "",
                    images: data.images,
                    message: data.messages,
                    status: "1"
                }
                if (CopyData.length > 0) {
                    const LastIndex = CopyData.length - 1;
                    const UpdateChat = {
                        ...CopyData[LastIndex],
                        chat: [Chat, ...CopyData[LastIndex].chat]
                    }
                    CopyData[LastIndex] = UpdateChat;
                    return CopyData;
                }
            });
        }

        const handleUserStatus = (data) => {
            if (data.userId == BookData?.astrologer_id) {
                setIsOnline(data.online);
            }
        };

        const handleTypingState = (data) => {
            if (data.sender_id == BookData?.astrologer_id) {
                setIsTyping(data.isTyping);
            }
        };

        socket.on(`user_status${BookData.appoint_id}`, handleUserStatus);
        socket.on(`typing_state${BookData.appoint_id}`, handleTypingState);
        socket.on(`end_chat_done${Userid}`, handleEndChat);
        socket.on(`Web_Device_Chat_Reaload${BookData.astrologer_id}`, handleWebNewChatReaload);
        socket.on(`New_Chat_Reaload${BookData.astrologer_id}`, handleNewChat);

        const onConnect = () => {
            console.log("Socket connected, emitting join_chat");
            socket.emit("join_chat", {
                userId: Userid,
                receiver_id: BookData?.astrologer_id,
                appoint_id: BookData?.appoint_id
            });
        };

        if (socket.connected) {
            onConnect();
        }

        socket.on("connect", onConnect);

        return () => {
            socket.off(`user_status${BookData.appoint_id}`, handleUserStatus);
            socket.off(`typing_state${BookData.appoint_id}`, handleTypingState);
            socket.off(`end_chat_done${Userid}`, handleEndChat);
            socket.off(`Web_Device_Chat_Reaload${BookData.astrologer_id}`, handleWebNewChatReaload);
            socket.off(`New_Chat_Reaload${BookData.astrologer_id}`, handleNewChat);
            socket.off("connect", onConnect);
        };
    }, [BookData, Userid]);

    useEffect(() => {
        if (!Userid || !BookData?.appoint_id) return;
        const timeOut = setTimeout(() => {
            handleGetUserData(page);
        }, 500);
        return () => clearTimeout(timeOut);
    }, [BookData, Userid]);

    useEffect(() => {
        if (chatBoxBodyRef.current) {
            chatBoxBodyRef.current.scrollTop = chatBoxBodyRef.current.scrollHeight;
        }
    }, [allchat]);

    useEffect(() => {
        if (!running) return;
        const interval = setInterval(() => {
            setChatTime(prev => HandleCountTime(prev));
            if (freeMinit !== "00:00") {
                setFreeMinit(prev => HandleFreeTime(prev));
            }
        }, 1000);
        return () => clearInterval(interval);
    }, [running]);

    useEffect(() => {
        if (chattime === "00:30") {
            setIsToast(true);
            setToastMsg(
                t("You have 30 seconds left. Please recharge immediately to continue the conversation.")
            );
        }
        if (chattime === "00:00" && status === "3") {
            socket.emit("chat_over_verify", { appoint_id: BookData?.appoint_id });
        }
    }, [chattime, status, BookData]);

    useEffect(() => {
        if (freeMinit === "00:01") {
            setIsToast(true);
            setToastMsg(
                t("Free chat over! Next minutes will use wallet balance.")
            );
        }
    }, [freeMinit]);

    useEffect(() => {
        if (page === 1 && !NoMoreDataRef.current) return;
        UserRef.current = false;
        handleGetUserData(page);
        setApiLoading("ChatLoad");
    }, [page])

    const handleGetUserData = async (page) => {
        if (UserRef.current) return;
        UserRef.current = true;

        const ApiData = {
            id: Userid,
            sender_id: Userid,
            recevier_id: BookData?.astrologer_id,
            appointment_id: BookData?.appoint_id,
            status: "user",
            page
        }

        const Response = await HandleCallApi("Post", "chat/user_to_user_chat_list", ApiData);
        const { user, chat_time, all_chat, appoint_data, free_verify } = Response.data;
        if (all_chat.length === 0) NoMoreDataRef.current = false;
        if (page === 1) {
            setAllChat(all_chat);
        } else {
            setAllChat(prev => [...all_chat, ...prev]);
        }
        setHasMore(true);
        setUserData(user[0]);
        setIsOnline(prev => prev || user[0]?.live_status == 1);
        setStatus(appoint_data?.status);
        const RatingData = {
            appointment_id: chat_time?.appoint_id,
            astrologer_detail: { image: user[0]?.logo, name: user[0]?.name },
            astrologer_id: chat_time?.astrologer_id,
            conversation_type: appoint_data?.appointment_type
        }
        if (free_verify?.isFirstTime === true && free_verify?.free_time !== "00:00") {
            setFreeMinit(free_verify?.free_time);
        }
        setRatingData(RatingData);
        if (chat_time.chat_time_remaining == "00:00" && chat_time?.review_status_astrologer == "0" && appoint_data?.status == "4") {
            setIsRating(true);
        } else {
            setChatTime(chat_time.chat_time_remaining || "00:00");
            setRunning(true);
        }
        setLoading(false);
        setApiLoading("");
    }

    const HandleCountTime = (time) => {
        const [min, sec] = time.split(":").map(Number);
        let total = min * 60 + sec - 1;

        if (total < 0) return "00:00";

        const MIN = String(Math.floor(total / 60)).padStart(2, "0");
        const SEC = String(total % 60).padStart(2, "0");

        return `${MIN}:${SEC}`;
    };

    const HandleFreeTime = (time) => {
        const [min, sec] = time.split(":").map(Number);
        let total = min * 60 + sec - 1;

        if (total < 0) return "00:00";

        const MIN = String(Math.floor(total / 60)).padStart(2, "0");
        const SEC = String(total % 60).padStart(2, "0");

        return `${MIN}:${SEC}`;
    };


    const handleChatEnd = async () => {
        setApiLoading("EndChat");
        const Response = await HandleCallApi("Post", "astro/end_chat", { appoint_id: BookData?.appoint_id });
        setIsToast(true);
        setToastMsg(Response.data.message);
        socket.emit("end_chat", { appoint_id: BookData?.appoint_id });
        setApiLoading("");
        setIsEnd(false);
        setIsRating(true);
        navigate("/");
    }

    const handleInputChange = (val) => {
        setInputMsg(val);
        if (!isMyTypingRef.current) {
            isMyTypingRef.current = true;
            socket.emit("typing_state", {
                appoint_id: BookData?.appoint_id,
                sender_id: Userid,
                receiver_id: BookData?.astrologer_id,
                isTyping: true
            });
        }
        if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
        typingTimeoutRef.current = setTimeout(() => {
            isMyTypingRef.current = false;
            socket.emit("typing_state", {
                appoint_id: BookData?.appoint_id,
                sender_id: Userid,
                receiver_id: BookData?.astrologer_id,
                isTyping: false
            });
        }, 2000);
    };

    const handleSendMessage = () => {

        if (!inputmsg) {
            setIsToast(true);
            setToastMsg(t("Write message !!"));
            return;
        }

        const SocketData = {
            id: Userid,
            sender_id: Userid,
            recevier_id: BookData?.astrologer_id,
            appoint_id: BookData?.appoint_id,
            message: inputmsg,
            images: [],
            status: "user",
            res_status: "0",
            dstatus: "0"
        }

        socket.emit("Add_new_chat", SocketData);
        const now = new Date();

        const timeString = now.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });


        setAllChat((prev) => {
            const CopyData = [...prev];

            const Chat = {
                date: timeString,
                id: "",
                images: [],
                message: inputmsg,
                status: "1"
            }

            if (CopyData.length > 0) {
                const LastIndex = CopyData.length - 1;
                const UpdateChat = {
                    ...CopyData[LastIndex],
                    chat: [Chat, ...CopyData[LastIndex].chat]
                }
                CopyData[LastIndex] = UpdateChat;
                return CopyData;
            }
        });

        setInputMsg("");
    }

    const handleContinueChat = async () => {
        const Userid = secureLocalStorage.getItem("Userid");
        if (Userid) {
            setApiLoading("ContinueChat");
            const Response = await HandleCallApi("Post", "user/user_kundli_list", { id: Userid });
            setKundliList(Response.data.kundli_list);
            setIsChatPayModel(true);
            setApiLoading("");
        }
    }

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            handleSendMessage();
        }
    }

    const handleScroll = (e) => {
        const { scrollTop } = e.target;
        if (scrollTop < lastScrollTop) {
            if (scrollTop <= 10 && hasMore && NoMoreDataRef.current) {
                setHasMore(false);
                setPage(prev => prev + 1);
            }
        }
        setLastScrollTop(scrollTop);
    };

    return (
        <div className='chat_page'>

            {!loading && <div className="width_cintainer">

                <div className="chat_box">

                    <div className="w-full bg-white px-[15px] py-[10px] shadow rounded-[10px]">
                        <div className="flex items-center justify-between gap-[20px]">
                            <div className="flex items-center gap-[15px]">
                                <button onClick={() => navigate(-1)}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M20.7501 12C20.7501 12.414 20.4141 12.75 20.0001 12.75H5.81115L8.53112 15.47C8.82412 15.763 8.82412 16.238 8.53112 16.531C8.38512 16.677 8.19309 16.751 8.00109 16.751C7.80909 16.751 7.61706 16.678 7.47106 16.531L3.47106 12.531C3.40206 12.462 3.3472 12.3791 3.3092 12.2871C3.2332 12.1041 3.2332 11.8971 3.3092 11.7141C3.3472 11.6221 3.40206 11.539 3.47106 11.47L7.47106 7.46999C7.76406 7.17699 8.2391 7.17699 8.5321 7.46999C8.8251 7.76299 8.8251 8.23803 8.5321 8.53103L5.81213 11.251H20.0001C20.4141 11.25 20.7501 11.586 20.7501 12Z" fill="black" />
                                    </svg>
                                </button>
                                <div className="relative">
                                    <ImageLoad url={BaseUrl + userdata?.logo} CustomeStyle={"w-[55px] h-[55px] rounded-full object-cover"} alt={"Chat user img"} />
                                    <span className={`absolute bottom-0 right-0 w-[12px] h-[12px] rounded-full border-2 border-white ${isOnline ? "bg-green-500" : "bg-gray-400"}`}></span>
                                </div>
                                <div className="leading-5">
                                    <h1 className='font-medium'>{userdata?.name}</h1>
                                    <div className="flex items-center gap-[10px]">
                                        {status != "4" && <span className={`font-medium text-[15px] ${freeMinit != "00:00" ? "text-green-600" : "text-red-600"}`}>{chattime}</span>}
                                        {status == "4" && <h1 className='text-[14px] text-green-500'>{t("Complete")}</h1>}
                                        {status != "4" && (
                                            isTyping ? (
                                                <span className="text-[12px] text-green-600 font-bold animate-pulse">{t("typing...")}</span>
                                            ) : (
                                                <span className="text-[12px] text-gray-500">{isOnline ? t("Online") : t("Offline")}</span>
                                            )
                                        )}
                                    </div>
                                </div>
                            </div>
                            {status == "3" && <button onClick={() => setIsEnd(true)} className='font-medium text-gray-600'>{t("End Chat")}</button>}
                        </div>
                    </div>

                    <div onScroll={handleScroll} ref={chatBoxBodyRef} className={`h-full my-[10px] bg-white rounded-[10px] p-[10px] shadow ${apiloading === "ChatLoad" ? "overflow-hidden" : "scroll_container"} relative`}>
                        <div className="flex flex-col flex-grow-1">
                            {apiloading === "ChatLoad" && <div className="absolute inset-0 w-full h-full flex items-center justify-center bg-black/10">
                                <Btn_loader CustomeStyle={"bg-[--bgcolor]"} />
                            </div>}
                            {allchat.map((item, index) => {
                                return <div key={index}>
                                    <h1 className='text-center'>{item.date}</h1>
                                    {[...item.chat].reverse().map((list, index) => {
                                        return <div key={index} className={`${list.status == 1 ? "text-end text-white" : "text-start text-black"}`}>
                                            <div style={{ borderRadius: list.status == 1 ? "10px 10px 0 10px" : "10px 10px 10px 0px" }} className={`message ${index !== 0 ? "mt-[10px]" : "mt-0"} ${list.status == 1 ? "bg-[--bgcolor]" : "bg-gray-200"}`}>
                                                <p className='font-medium text-[15px] whitespace-pre-line text-start'>
                                                    {list.message}
                                                </p>
                                                <p className='text-[14px] mt-[5px]'>{list.date}</p>
                                            </div>
                                        </div>
                                    })}
                                </div>
                            })}
                        </div>
                    </div>

                    {status != "4" && <div className="w-full bg-white px-[15px] py-[10px] shadow rounded-[10px]">
                        <div className="flex items-center gap-[10px]">
                            <input type="text" value={inputmsg} onChange={(e) => handleInputChange(e.target.value)} onKeyDown={handleKeyDown} className='w-full focus-within:outline-[--bgcolor] border-[2px] rounded-[10px] px-[15px] py-[8px]' placeholder={`${t("Message")} ${userdata?.name}`} />
                            <button onClick={handleSendMessage} className='bg-[--bgcolor] p-[10px] rounded-full'>
                                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20.9271 3.07299C20.2251 2.37099 19.231 2.095 18.265 2.336L5.15221 5.61401C3.40421 6.05101 2.23808 7.55499 2.25108 9.35699C2.26408 11.159 3.45021 12.646 5.20421 13.059L9.85021 14.152L10.9432 18.797C11.3562 20.551 12.8431 21.737 14.6451 21.75C14.6541 21.75 14.6642 21.75 14.6732 21.75C16.4622 21.75 17.9521 20.587 18.3871 18.849L21.6651 5.73599C21.9051 4.77099 21.6301 3.77599 20.9271 3.07299ZM20.2091 5.37201L16.931 18.485C16.602 19.798 15.5412 20.258 14.6542 20.25C13.8092 20.244 12.7132 19.77 12.4032 18.454L11.2992 13.763L15.5301 9.531C15.8231 9.238 15.8231 8.763 15.5301 8.47C15.2371 8.177 14.7621 8.177 14.4691 8.47L10.2372 12.702L5.54601 11.598C4.22901 11.288 3.75513 10.191 3.74913 9.346C3.74313 8.50101 4.20202 7.397 5.51402 7.069L18.6271 3.79098C18.7341 3.76398 18.8421 3.751 18.9481 3.751C19.2881 3.751 19.6161 3.885 19.8651 4.134C20.1921 4.46 20.3211 4.92301 20.2091 5.37201Z" fill="white" />
                                </svg>
                            </button>
                        </div>
                    </div>}

                    {status == "4" && <div className="w-full bg-orange-50 p-[15px] border shadow rounded-[10px]">
                        <div className="bg-orange-100 p-[10px] rounded-[10px] flex items-center gap-[15px]">
                            <ImageLoad url={BaseUrl + userdata?.logo} CustomeStyle={"w-[45px] h-[45px] border border-[--bgcolor] rounded-full object-cover"} alt={"Chat user img"} />
                            <p>{t("Hi")} {userdata?.name}, {t("lets continue this chat at discounted price of")} {formatPrice((userdata?.chat_min_req_time * userdata?.chat_offer_price), 1)}/{t("min")}</p>
                        </div>
                        <button onClick={handleContinueChat} className='w-full bg-[--bgcolor] text-white h-[40px] rounded-[10px] font-medium mt-[10px]'>
                            {apiloading === "ContinueChat"
                                ? <Btn_loader CustomeStyle={"bg-white"} />
                                : t("Continue Chat")}
                        </button>
                    </div>}

                </div>

            </div>}

            {isend && <div onClick={() => setIsEnd(false)} className="model items-center">
                <div onClick={(e) => e.stopPropagation()} className="w-[300px] bg-white p-[20px] rounded-[15px]">
                    <h1 className='font-medium text-[17px] text-center'>{t("End Chat")}</h1>
                    <p className='leading-5 text-[15px] text-gray-600'>{t("Are you sure you want to end tha chat to")} {userdata?.name}?</p>

                    <div className="flex items-center gap-[20px] mt-[15px]">
                        <button onClick={() => setIsEnd(false)} className='w-full h-[35px] border border-gray-400 rounded-full font-medium hover:shadow-md duration-[0.3s]'>{t("No")}</button>
                        <button onClick={handleChatEnd} className='w-full h-[35px] bg-green-500 border border-green-500 text-white rounded-full font-medium hover:shadow-md duration-[0.3s]'>
                            {apiloading === "EndChat"
                                ? <Btn_loader CustomeStyle={"bg-white"} />
                                : t("Yes")}
                        </button>
                    </div>
                </div>
            </div>}

            {ischatpaymodel && <BookApoint KundliList={kundlilist} userdata={userdata} isclickindex={1} setIsChatPayModel={setIsChatPayModel} user_wallet={userdata?.user_wallet} />}

            <PageLoading loading={loading} />

        </div >
    )
}

export default Chat